
import './App.css';
import Weather from "./Weather";
import Footer from "./Footer";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App App-header">
      <div className="container">
      <Weather defaultCity="Lisbon" />

      <Footer />
</div>
    </div>
  );
}

export default App;
